let languageCode = 'en';
module.exports = {
	languageCode,
	endonym: 'English',
	displayValue: 'English',
	raadELLPurpose:
		'Words are where humans store knowledge. So you will build your knowledge by reading these articles. You will also increase your vocabulary, improve your reading stamina, and enjoy reading every day!',
	raadELLPurposeAudio: '/assets/dist/audio/set_the_purpose_' + languageCode + '.mp3',
	raadELLMindset:
		'These articles are full of knowledge. You will learn new and important things by reading them. You will not know many of the things you read about. That’s great! Reading is one way you can learn new things. And when you learn some new things, it gets easier to learn even more new things! Maybe you will already know some of the things in these articles. That’s great also. When you read more about the things you already know, you will increase your own vocabulary. This will help you to understand new, big ideas. Finally, you will become a stronger reader by reading these articles. You will be able to read for longer periods of time. Happy Reading!',
	raadELLMindsetAudio: '',
	raadELLChooseOne: 'Please choose one article to read now.',
	raadELLChooseOneAudio: '/assets/dist/audio/aad_instructions_' + languageCode + '.mp3',
	raadELLBOKDirectionsLabel: 'Directions:',
	raadELLBOKWrite: 'Please write 2 or 3 things you have learned from this article that you want to remember.',
	raadELLBOKWriteAudio: '/assets/dist/audio/bok_instructions_' + languageCode + '.mp3',
	rtl: false,
	workspacePTInstructions: 'Please read the Spanish article, then read the English article and answer the questions.',
	ok: 'OK'
};
